function spreadToEvenBits(n: number, depth: number): bigint {
    let result = 0n
    for (let i = 0; i < depth; i++) {
        if (n & (1 << i)) result |= 1n << BigInt(i * 2)
    }
    return result
}

function compactFromEvenBits(x: bigint, depth: number): number {
    let result = 0
    for (let i = 0; i < depth; i++) {
        if (x & (1n << BigInt(i * 2))) result |= 1 << i
    }
    return result
}

export function mortonEncode(lat: number, lon: number, depth: number): bigint {
    const maxCoord = 2 ** depth - 1
    const qLat = Math.round(((lat + 90) / 180) * maxCoord) & maxCoord
    const qLon = Math.round(((lon + 180) / 360) * maxCoord) & maxCoord
    return spreadToEvenBits(qLat, depth) | (spreadToEvenBits(qLon, depth) << 1n)
}

export function mortonDecode(morton: bigint, depth: number): [number, number] {
    const maxCoord = 2 ** depth - 1
    const qLat = compactFromEvenBits(morton, depth)
    const qLon = compactFromEvenBits(morton >> 1n, depth)
    return [(qLat / maxCoord) * 180 - 90, (qLon / maxCoord) * 360 - 180]
}
